import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslationService } from '../translation.service';

@Injectable()
export class TitlesService {
  constructor(
    private title: Title,
    private translationService: TranslationService
  ) { }

  setTitle(value: string) {
    this.title.setTitle(value);
  }

  async setTranslatingTitle(value: string, params?: { [key: string]: any }) {
    const translation = await this.translationService.getTranslation(value, params);
    this.setTitle(translation);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/services/visual/titles.service.ts